import { defineMessages } from 'react-intl';

export const assessmentRecommendationDetailsMessages = defineMessages({
	closeLabel: {
		id: 'fastshift.dc-instance-details.recommendation-panel.close',
		defaultMessage: 'Close recommendation details',
		description: 'Accessible label for the side panel close button',
	},
	loadingLabel: {
		id: 'fastshift.dc-instance-details.recommendation-panel.loading',
		defaultMessage: 'Loading recommendation details',
		description: 'Accessible loading label for recommendation details',
	},
	errorMessage: {
		id: 'fastshift.dc-instance-details.recommendation-panel.error-message',
		defaultMessage: 'We couldn’t load the details for this check.',
		description: 'Message shown when assessment check details fail to load',
	},
	recommendationsTitle: {
		id: 'fastshift.dc-instance-details.recommendation-panel.recommendations-title',
		defaultMessage: 'Recommendations',
		description: 'Heading for recommendation insights',
	},
	resourcesTitle: {
		id: 'fastshift.dc-instance-details.recommendation-panel.resources-title',
		defaultMessage: 'Resources',
		description: 'Heading for recommendation resource links',
	},
	learnMore: {
		id: 'fastshift.dc-instance-details.recommendation-panel.learn-more',
		defaultMessage: 'Learn more about this insight',
		description: 'Link label for learning more about an assessment result',
	},
});
